$(document).ready(function() {
  var swiperThumb = new Swiper("#product_thumbnails", {
      spaceBetween: 10,
      slidesPerView: 3.5,
      observer: true, 
      observeParents: true,
      slidesOffsetAfter: 10,
      // simulateTouch: true,
      scrollbar: {
        draggable: true,
      },
      breakpoints: {
        480: {
          slidesPerView: 5.5,
        }
      }
    });

  var swiperFeatured = new Swiper("#product_media_mobile", {
      slidesPerView: 1.15,
      spaceBetween: 15,
      observer: true, 
      observeParents: true,
      slidesOffsetAfter: 15,
      thumbs: {
        swiper: swiperThumb,
      },
      on: {
        realIndexChange: (swiper) => {
          if(swiper.realIndex != 0) {
            $('#featured_stickers').hide();
          }else {
            $('#featured_stickers').show();
          }
        }
      },
    });

  window.reInitSwiper = function (e) {
    swiperThumb = new Swiper("#product_thumbnails", {
      spaceBetween: 10,
      slidesPerView: 5,
      // simulateTouch: true,
      observer: true, 
      observeParents: true,
    });

    swiperFeatured = new Swiper("#product_media_mobile", {
      slidesPerView: 1.15,
      spaceBetween: 15,
      observer: true, 
      observeParents: true,
      thumbs: {
        swiper: swiperThumb,
      },
      on: {
        realIndexChange: (swiper) => {
          if(swiper.realIndex != 0) {
            $('#featured_stickers').hide();
          }else {
            $('#featured_stickers').show();
          }
        }
      },
    });
  }


  Fancybox.bind("[data-fancybox]", {
    Thumbs: {
      type: "classic",
    },
  });

  $('#slide3').click(swiperFeatured,function(){
    const sliderWrapper = document.querySelector('#product_media_mobile');
    const slides = [...sliderWrapper.querySelectorAll('.swiper-slide')];
    const index = slides.findIndex(slide => 
      slide.querySelector('.video-inner-wrapper')
    );
    console.log(index);
    if (index !== -1) swiperFeatured.slideTo(index);
  });

  function loadInitialImages() {
    //console.log('loadInitialImages');
    let initial_image = '';
    if ($(".swatch div.swatch-element input[name='option-1']:checked").length) {
      initial_image = $(".swatch div.swatch-element input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-').replace('"','');
    }

    var checked_variant_size = false;
     if($('body').attr('id') === 'desk-mat' || $('body').attr('id').includes('orbitkey-desk-mat') || $('body').attr('id').includes('hybrid-laptop-sleeve') || $('body').attr('id').includes('compendium')  ) {
        if ($(".product-details-wrapper input[name='option-2']").length) {
          //console.log('is option 2: ' + $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-'));
          var checked_variant_size = $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-');
        }
      }
      if(checked_variant_size){
        //initial_image = initial_image+'-'+checked_variant_size;
      }
    if ($(".product-details-wrapper input[name='option-2']").length) {
      //console.log('is option 2: ' + $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-'));
      var option_2 = $(".product-details-wrapper input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-').replace('"','');
      if (option_2) {
        initial_image = initial_image+'-'+option_2;
      }
    }

    //console.log(initial_image);

    document.querySelector('#product_media_mobile .swiper-wrapper').querySelectorAll('.product-medias__media').forEach(block => {
      const swatch = block.getAttribute('data-swatch');
      if (swatch === 'all' || swatch === initial_image) {
        block.style.display = '';
        block.classList.add('swiper-slide');
      } else {
        block.style.display = 'none';
        block.classList.remove('swiper-slide');
      }
    });

    document.querySelector('#product_thumbnails .product-thumbs-slider').querySelectorAll('.product-thumbs-slides').forEach(block => {
      const swatch = block.getAttribute('data-swatch');
      if (swatch === 'all' || swatch === initial_image) {
        block.style.display = '';
        block.classList.add('swiper-slide');
      } else {
        block.style.display = 'none';
        block.classList.remove('swiper-slide');
      }
    });

    // 1. Force Swiper to re-scan the DOM for new slides
    swiperThumb.update();
    swiperFeatured.update();
    // 2. CRITICAL: Re-sync the internal connection
    // This tells the main slider to check the thumbnail slider again
    swiperFeatured.thumbs.swiper = swiperThumb;
    swiperFeatured.thumbs.init(); // Re-bind click events
    swiperFeatured.thumbs.update(true); // Refresh active classes
    // 3. Optional: Reset to first slide to prevent index errors
    swiperFeatured.slideTo(0);
    swiperThumb.slideTo(0);

    document.querySelector('#product_media_main_desktop .desktop-grid-wrapper').querySelectorAll('.desktop-grid-blocks').forEach(block => {
      const swatch = block.getAttribute('data-swatch');
      if (swatch === 'all' || swatch === initial_image) {
        block.style.display = '';
      } else {
        block.style.display = 'none';
      }
    });

    Fancybox.unbind("[data-fancybox]");
    const selector = ".desktop-grid-blocks[data-swatch='" + initial_image + "'] [data-fancybox], .desktop-grid-blocks[data-swatch='all'] [data-fancybox]";
    Fancybox.bind(selector, {
      Thumbs: { type: "classic" },
      groupAll: true, 
      groupAttr: false,
    });

  }

  loadInitialImages();
  setTimeout(function(){
    if($('.product-single-wrapper .swatch .color.swatch-element input:checked+label').length) {
      $('.product-single-wrapper .swatch .color.swatch-element input:checked+label')[0].click();
    }
  },50);

  $(".swatch div.swatch-element:not(.bundle-default)").unbind('click');
  $(".swatch div.swatch-element:not(.bundle-default)").click(function() {
    const swiper_thumbnails = $('#product_thumbnails .swiper-wrapper');
    const swatch_wrapper = $(this).closest('.swatch');
    const swatch_header = $(this).closest('.swatch').find('.color-switch-header');
    const swatch_index = parseInt(swatch_wrapper.data('option-index')) + 1;
    //$('#product_thumbnails .swiper-wrapper .swiper-slide').remove();
    //$('#product_media_mobile .swiper-wrapper .swiper-slide').remove();
    loadInitialImages();
    swatch_header.html(swatch_header.data('swatch') + ': ' + $("input[name='option-"+swatch_index+"']:checked").val());
  });

  // const lettersOnlyInput = $('#bold_options_div .tb_2002472_327268');
  $("body").on("click","#bold_options_div .bold_option_radio input:radio", function(e) {
    $('.bold_option_value_title').css({'backgroundColor': '#fff','color': '#000'});
    if(this.value != 'No') {
      $('#AddToCart.bold_clone').prop('disabled',true);
      $('#AddToCart.bold_clone').css({ opacity: 0.6 });
      $(this).parent().parent().find('.bold_option_value_title').css({'backgroundColor': '#000','color': '#fff'});
    } else {
      $('#AddToCart.bold_clone').prop('disabled',false);
      $('#AddToCart.bold_clone').css({ opacity: 1 });
      $(this).parent().parent().find('.bold_option_value_title').css({'backgroundColor': '#000','color': '#fff'});
    }

    // IF THIS MONOGRAMMING IS INSIDE EXTENSION, CHANGE THE TITLE
    if( $(this).closest('.product-extension-wrapper').length ) {
      var extensionWrapper = $(this).closest('.product-extension-wrapper')[0];
      var productHeader = extensionWrapper.querySelector('.product-extension-item__product-inner-top');
      var monogramDisclaimer = extensionWrapper.querySelector('.monogram-disclaimer');
      if (monogramDisclaimer) {
        monogramDisclaimer.style.display = (this.value != 'No') ? 'flex' : 'none';
      }
      if(this.value != 'No') {
        productHeader.classList.add('selected');
        setTimeout(function(){
          var price = '';
          var boldVariant = document.querySelector('[name="properties[_boldVariantPrices]"]');
          var boldVariantPrice = 0;
          if(boldVariant) {
            boldVariantPrice = parseFloat(parseInt(boldVariant.value)/100);
          }
          price = '$' + boldVariantPrice.toFixed(2) + ' AUD';
          if(productHeader.querySelector('.product-extension-item__product-price .money')) {
            productHeader.querySelector('.product-extension-item__product-price .money').textContent = price;
          }

          const inputField = document.querySelector('input[name="properties[Initials (Capital letters only)*]"]');
          if (inputField) {
            // Clone the element without its listeners
            const clonedField = inputField.cloneNode(true);
            // Replace the original element with the clone
            inputField.parentNode.replaceChild(clonedField, inputField);
            // Add any desired listeners to the cloned element
            clonedField.addEventListener('keydown', function(event) {
              if (event.key === 'Enter') {
                event.preventDefault();
              }
            });
          }

        },50);
      } else {
        productHeader.classList.remove('selected');
      }
    }

    // IF THIS MONOGRAMMING IS INSIDE EXTENSION, LET IT SIZE TO ITS CONTENT
    // (a measured height goes stale as soon as a warning or error message is added)
    if( $(this).closest('.product-extension-item__product-inner-bottom').length ) {
      var content = $(this).closest('.product-extension-item__product-inner-bottom')[0];
      content.style.height = '';
      content.style.maxHeight = '';
    }

    // CALCULATE EXTENSION TOTAL PRICE
    setTimeout(function(){
      //console.log($('[name="properties[_boldVariantPrices]"]').val());
      window.extensionTotal();
      window.stickyAddToCartBar();
    },50);
  });

  $("body").on("keyup","#bold_options_div .bold_option_element input", function(e) {
    this.value = this.value.replace(/[^a-zA-Z]/g, '').toUpperCase();
    var key = e.keyCode;
      if (key >= 48 && key <= 57) {
          e.preventDefault();
      }

    if(this.value.length < 1) {
      $('#AddToCart.bold_clone').prop('disabled',true);
      $('#AddToCart.bold_clone').css({ opacity: 0.6 });
    } else {
      $('#AddToCart.bold_clone').prop('disabled',false);
      $('#AddToCart.bold_clone').css({ opacity: 1 });
    }
  });

  var _carousel_swiper = new Swiper(".owl-carousel-desk-mat-compare", {
      spaceBetween: 0,
      slidesPerView: 3,
      loop: false,
      dots: false,
      breakpoints: {
        0:{
            slidesPerView:1,
            spaceBetween:0,
        },
        600:{
            slidesPerView:1,
			spaceBetween:10,
        },
        769:{
            slidesPerView:1,
			spaceBetween:10,
        },
        1000:{
            slidesPerView:3,
			spaceBetween:0,
        }
      }

      // simulateTouch: true,
    });



  if($('.desk-mat-compare-buttons .swatch-element').length) {
    $('.desk-mat-compare-buttons .swatch-element').click(function() {
      const _this = $(this);
      let sizeSwatch = $('.desk-mat-compare-buttons input[type="radio"]:checked');
	  // If swatches are checked
      if(sizeSwatch.length) {
        if(sizeSwatch.val() == 1) {
          $(".owl-carousel-desk-mat-compare[data-slider-id='0'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").toggleClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").addClass('hide');
        } else if(sizeSwatch.val() == 2) {
          $(".owl-carousel-desk-mat-compare[data-slider-id='0'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").toggleClass('hide');
        } else {
           $(".owl-carousel-desk-mat-compare[data-slider-id='0'").toggleClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='1'").addClass('hide');
          $(".owl-carousel-desk-mat-compare[data-slider-id='2'").addClass('hide');
        }
      } else {
       $('.desk-mat-compare-buttons input[type="radio"]').first().prop("checked", true);
      }
    });
   }

});
